module.exports = __webpack_public_path__ + "img/UTDEAD-1.d318a8dc.jpg";